import { useDispatch } from 'react-redux';

import store from '../store/store';

export type AppDispatch = typeof store.dispatch

export function useAppDispatch() {
	return useDispatch<AppDispatch>()
}
